export const getSafeAuthRedirect = (value, fallback = "/calendar") => {
  if (
    typeof value !== "string" ||
    !value.startsWith("/") ||
    value.startsWith("//")
  ) {
    return fallback;
  }

  const path = value.split(/[?#]/, 1)[0];
  if (path === "/login") {
    return fallback;
  }

  return value;
};
